import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, message } from "antd";
import Swal from "sweetalert2";
import { fetchAdminLeaves, updateAdminRequest, updateAdminRequestAsync } from "../../../Slices/adminLeaveSlice";

import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../components/modelpopup/EmployeeLeaveModelPopup";
import LeaveFilter from "../../../components/LeaveFilter";
import { useSelector } from "react-redux";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { AntdButton, SelectInput, TextareaField } from "../../../blueplanitUtils/InputField";
import { getOptionsByPath } from "../../../utilsdata";
import { ADMIN_LEAVES, LEAVE_STATUS } from "../../../Dropdownmanager";

import dayjs from "dayjs";
import { AdminLeaveAddModelPopup } from "../../../components/modelpopup/AdminLeaveModelPopup";
import { FileSearchOutlined } from "@ant-design/icons";

const AdminLeave = () => {
  const dispatch = useDispatch();
  const employees = useSelector((state) => state.loginUserInfo.allUsers);
  const adminLeaves = useSelector((state) => state?.adminLeave?.leaves);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const [sortObject, setSortObject] = useState({});


  const [originalLeaves, setOriginalLeaves] = useState([]);
  const [leavesSnapshot, setLeavesSnapshot] = useState([]);
  const [isEditingBulk, setIsEditingBulk] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);

  const [activeModal, setActiveModal] = useState(null);
  const tableRefs = React.useRef({});


  const DEPARTMENT_ORDER = [
    "IT",
    "Sales",
    "Operations",
    "HR & Admin",
    "Both",
    "Other",
  ];


  useEffect(() => {
    setSortObject({ startDate: "desc" });
  }, []);



  const handleSort = (sorter) => {

    const newSortObject = sorter?.order
      ? { [sorter.field]: sorter.order === "ascend" ? "asc" : "desc" }
      : {};

    setSortObject(newSortObject);


    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const sortedLeaves = Array.isArray(adminLeaves)
    ? [...adminLeaves].sort(
      (a, b) => Number(new Date(b.createdAt)) - Number(new Date(a.createdAt))
    )
    : [];

  const format_date = (timestamp) => {
    if (!timestamp) return "N/A";

    const ts = Number(timestamp);

    return dayjs(ts).format("DD/MM/YYYY");
  };

  const formatDateTime = (timestamp) => {
    if (!timestamp) return "N/A";
    return dayjs(Number(timestamp)).format("DD/MM/YYYY hh:mm A");
  };

  const updatedAdminLeaves = sortedLeaves
    .map((leave) => {
      const employee = employees.find(
        (emp) => String(emp.id) === String(leave.employeeId)
      );

      return {
        ...leave,
        username: employee ? employee.firstname + " " + employee.lastname : null,
        department: employee ? employee.department : null,
      };
    })
    .sort((a, b) => b.createdAt - a.createdAt);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const [paginationMap, setPaginationMap] = useState({
    IT: { current: 1, pageSize: 10 },
    Sales: { current: 1, pageSize: 10 },
    Operations: { current: 1, pageSize: 10 },
    "HR & Admin": { current: 1, pageSize: 10 },
    Both: { current: 1, pageSize: 10 },
    Other: { current: 1, pageSize: 10 },
  });

  const getSortedAndPaginatedData = (data, dept) => {
    let sorted = [...data];

    if (sortObject.startDate) {
      sorted.sort((a, b) => {
        const aDate = new Date(a.startDate);
        const bDate = new Date(b.startDate);
        return sortObject.startDate === "asc"
          ? aDate - bDate
          : bDate - aDate;
      });
    }

    const { current, pageSize } = paginationMap[dept];
    return sorted.slice((current - 1) * pageSize, current * pageSize);
  };

  const total = updatedAdminLeaves.length;

  const pageSizeOptions =
    total <= 50
      ? ["50"]
      : total <= 100
        ? ["50", "100"]
        : total <= 150
          ? ["30", "50", "150"]
          : ["30", "50", "150", "200"];

  const handlePageChange = (page, pageSize) => {
    setPagination({
      current: page,
      pageSize,
    });
  };

  const leavesByDepartment = React.useMemo(() => {
    const grouped = {};

    DEPARTMENT_ORDER.forEach((dept) => {
      grouped[dept] = [];
    });

    updatedAdminLeaves?.forEach((leave) => {
      const normalizedDept =
        leave.department?.trim().toLowerCase() || "other";

      const matchedDept = DEPARTMENT_ORDER.find(
        (dept) => dept.trim().toLowerCase() === normalizedDept
      );

      if (matchedDept) {
        grouped[matchedDept].push(leave);
      } else {
        grouped["Other"].push(leave);
      }
    });

    return grouped;
  }, [updatedAdminLeaves]);





  const sortedData = React.useMemo(() => {
    let data = [...updatedAdminLeaves];

    if (sortObject.startDate) {
      data.sort((a, b) => {
        const dateA = new Date(a.startDate);
        const dateB = new Date(b.startDate);
        return sortObject.startDate === "asc"
          ? dateA - dateB
          : dateB - dateA;
      });
    }

    return data;
  }, [updatedAdminLeaves, sortObject]);


  const paginatedData = React.useMemo(() => {
    return sortedData.slice(
      (pagination.current - 1) * pagination.pageSize,
      pagination.current * pagination.pageSize
    );
  }, [sortedData, pagination]);


  const handleTableChange = (dept) => (pager, filters, sorter) => {
    // ✅ Always update pagination (for page & pageSize change)
    setPaginationMap((prev) => ({
      ...prev,
      [dept]: {
        current: pager.current,
        pageSize: pager.pageSize,
      },
    }));

    // ✅ Handle sorting separately
    if (sorter && sorter.field === "startDate") {
      setSortObject({
        startDate:
          sorter.order === "ascend"
            ? "asc"
            : sorter.order === "descend"
              ? "desc"
              : undefined,
      });
    }
  };




  const teamReports =
    loginUser?.teamsReportDirect?.map(item => item.reportingId) || [];

  const role = loginUser?.role;
  const department = loginUser?.department;

  const hasDirectReports = teamReports.length > 0;

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [adminLeaves]);




  useEffect(() => {
    if (adminLeaves?.length > 0 && originalLeaves?.length === 0) {
      setOriginalLeaves(adminLeaves?.map((leave) => ({ ...leave })));
    }
  }, [adminLeaves]);

  const handleEditClick = (record) => {
    setSelectedLeave(record);
    setActiveModal("edit");   // 👈 open admin modal
    setIsModalOpen(true);
  };


  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedLeave(null);
    setActiveModal(null);
  };

  const toggleBulkEdit = () => {
    if (!isEditingBulk) {
      setLeavesSnapshot(adminLeaves.map((leave) => ({ ...leave })));
      setIsEditingBulk(true);
      return;
    }

    const updatedRecords = adminLeaves
      ?.filter((admin) => admin.isUpdated)
      ?.map((admin) => ({
        leaveId: admin._id,
        newStatus: admin.leaveStatus,
        remarks: admin.remarks,
        approvedBy: loginUser?.firstname + " " + loginUser?.lastname
      }));

    if (updatedRecords.length > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to submit these changes.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel"
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const resultAction = await dispatch(updateAdminRequestAsync(updatedRecords));

            if (updateAdminRequestAsync.fulfilled.match(resultAction)) {
              message.success("Leave changes have been submitted!");
              dispatch(
                updateAdminRequest(
                  adminLeaves.map((leave) => ({
                    ...leave,
                    isUpdated: false
                  }))
                )
              );
              setIsEditingBulk(false);
            } else {
              throw new Error(resultAction.payload || "Update failed");
            }
          } catch (error) {
            console.error("Error submitting leave status updates", error);
            message.error("An error occurred while submitting the changes.");
          }
        }
      });
    } else {
      message.info("No changes to submit.");
    }
  };

  const handleClear = () => {
    setIsEditingBulk(false);
    if (leavesSnapshot.length > 0) {
      dispatch(
        updateAdminRequest(
          leavesSnapshot.map((leave) => ({ ...leave, isUpdated: false }))
        )
      );
    }
    message.info("Changes have been cleared");
  };

  const handleStatusChange = (key, field, value) => {
    if (originalLeaves.length === 0) {
      setOriginalLeaves(
        adminLeaves.map((leave) => ({
          _id: leave._id,
          leaveStatus: leave.leaveStatus
        }))
      );
    }
    const updatedLeave = adminLeaves.map((leave) =>
      leave._id === key ? { ...leave, [field]: value, isUpdated: true } : leave
    );
    dispatch(updateAdminRequest(updatedLeave));
  };

  const handleChange = (key, field, value) => {
    if (originalLeaves.length === 0) {
      setOriginalLeaves(
        adminLeaves.map((leave) => ({
          _id: leave._id,
          remarks: leave.remarks
        }))
      );
    }
    const updatedLeave = adminLeaves.map((leave) =>
      leave._id === key ? { ...leave, [field]: value, isUpdated: true } : leave
    );
    dispatch(updateAdminRequest(updatedLeave));
  };

  const enrichedLeaves = teamReports.map(id => {
    const employee = employees.find(emp => emp.id === id);
    return {
      employeeId: employee?.id || null,
      username: employee ? `${employee.firstname} ${employee.lastname}` : null,
      department: employee?.department || null,
      leavesSettings: employee?.leavesSettings || [],
    };
  });

  const employeeList = Array.from(
    new Map(enrichedLeaves.map(emp => [emp.employeeId, emp])).values()
  );

  const columns = [
    {
      title: "Employee",
      dataIndex: "username",
      width: 180
    },
    {
      title: "Department",
      dataIndex: "department",
      width: 150,
      render: (text) => text || "-"
    },
    {
      title: "Leave Type",
      dataIndex: "leaveType",
      width: 130,
      render: (text) => <span>{text}</span>
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => format_date(date),
    },
    {
      title: "From",
      dataIndex: "startDate",
      key: "startDate",
      sorter: true,
      sortDirections: ["ascend", "descend"],
      render: (text) => <span>{dayjs(text).format("DD/MM/YYYY")}</span>
    },

    {
      // disableDrag: true,
      title: "To",
      dataIndex: "endDate",
      render: (text) => <span>{dayjs(text).format("DD/MM/YYYY")}</span>
    },
    { title: "No Of Days", dataIndex: "leaveDays" },
    {
      title: "Reason",
      dataIndex: "leaveReason",
      render: (text) => <span>{text}</span>
    },
    {
      title: "Leave Status",
      dataIndex: "leaveStatus",
      width: 130,
      render: (text, record) => {
        // If employee cancelled their own leave, show "Revoked"
        if (record.status === "false") {
          return <span style={{ color: "#6B7280", fontWeight: 500 }}>Revoked</span>;
        }
        // If admin rejected, show "Rejected" instead of "Declined"
        if (record.leaveStatus === "Declined") {
          return <span style={{ color: "#EF4444", fontWeight: 500 }}>Rejected</span>;
        }
        if (isEditingBulk) {
          const isSuperOrHR = role === "Super Admin" || department === "HR & Admin";
          const isDirectReport = teamReports.includes(record.employeeId);
          const canApprove = isSuperOrHR || isDirectReport;
          return (
            <div style={{ width: "150px" }}>
              <SelectInput
                value={record.leaveStatus}
                onChange={(value) =>
                  handleStatusChange(record._id, "leaveStatus", value)
                }
                disabled={
                  !canApprove ||
                  record.leaveStatus === "Approved" ||
                  record.leaveStatus === "Declined" ||
                  !isEditingBulk
                }
                options={getOptionsByPath(NestedDatabucket, [
                  ADMIN_LEAVES,
                  LEAVE_STATUS
                ])}
              />
            </div>
          );
        }
        return text;
      }
    },

    {
      title: "Approved By",
      dataIndex: "approvedBy",
      width: 160,
      render: (text, record) => {
        if (record.status === "false" || record.leaveStatus === "Pending") return "-";
        return text || "-";
      }
    },
    {
      title: "Approved At",
      dataIndex: "approvedAt",
      width: 200,
      render: (text, record) => {
        if (record.status === "false" || record.leaveStatus === "Pending") return "-";

        const time = record.updatedAt;
        return formatDateTime(time);
      }
    },

    {
      title: "Remarks",
      dataIndex: "remarks",
      width: 170,
      render: (text, record) => {
        const isDisabled = record.leaveStatus === "Approved";
        if (isEditingBulk) {
          return (
            <div style={{ width: "150px" }}>
              <TextareaField
                value={record.remarks || ""}
                onChange={(e) =>
                  handleChange(record._id, "remarks", e.target.value)
                }
                rows={2}
                disabled={isDisabled || !isEditingBulk}
              />
            </div>
          );
        }
        return text;
      }
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => {
        if (record.status === "false" || record.leaveStatus === "Declined")
          return null;

        // Can only approve/edit if Super Admin, HR & Admin, or the employee's reporting manager
        const isSuperOrHR = role === "Super Admin" || department === "HR & Admin";
        const isDirectReport = teamReports.includes(record.employeeId);
        const canApprove = isSuperOrHR || isDirectReport;

        return (
          <AntdButton
            label="Edit"
            className="btn btn-primary"
            onClick={() => handleEditClick(record)}
            disabled={
              !canApprove ||
              (record.leaveStatus !== "Pending" &&
              record.leaveStatus !== "Declined")
            }
          />
        );
      }
    }
  ];


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <LeaveFilter />

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">

                <Row justify="end" style={{ marginBottom: 16 }}>

                  <Col>
                    <AntdButton
                      label="Add Leave"
                      type="primary"
                      style={{ marginRight: 8, background: "#28a745" }}
                      onClick={() => {
                        setSelectedLeave(null);
                        setActiveModal("add");
                        setIsModalOpen(true);
                      }}

                    />
                  </Col>

                  <Col>
                    {Array.isArray(updatedAdminLeaves) &&
                      updatedAdminLeaves.length > 0 && (
                        <AntdButton
                          label={isEditingBulk ? "Submit" : "Edit"}
                          onClick={toggleBulkEdit}
                          type="primary"
                          style={{ marginRight: 8 }}
                        />
                      )}
                  </Col>

                  {isEditingBulk && (
                    <Col>
                      <AntdButton
                        label="Clear"
                        style={{ marginRight: 8 }}
                        onClick={handleClear}
                      />
                    </Col>
                  )}
                </Row>
                {updatedAdminLeaves.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "60px 0", color: "#bbb" }}>
                    <FileSearchOutlined style={{ fontSize: 64, marginBottom: 16, color: "#d9d9d9" }} />
                    <div style={{ fontSize: 16, fontWeight: 500, color: "#999" }}>No Records Found</div>
                    <div style={{ fontSize: 13, marginTop: 4, color: "#bbb" }}>
                      Try adjusting your filters or search criteria.
                    </div>
                  </div>
                ) : (
                  Object.entries(leavesByDepartment)
                    .filter(([dept, data]) => data.length > 0)
                    .map(([dept, data]) => {
                      if (!tableRefs.current[dept]) {
                        tableRefs.current[dept] = React.createRef();
                      }
                      return (
                        <div
                          key={dept}
                          ref={tableRefs.current[dept]}
                          style={{ marginBottom: 32, position: "relative" }}
                        >
                          <h4 style={{ marginBottom: 12 }}>{dept}</h4>
                          <CustomGridTable
                            Id={`admin-leave-table-${dept}`}
                            columns={columns}
                            rowKey="_id"
                            className="table-striped"
                            dataSource={getSortedAndPaginatedData(data, dept)}
                            onChange={handleTableChange(dept)}
                            popupContainerRef={tableRefs.current[dept]}
                            scroll={{ x: "max-content" }}   // ✅ ADD THIS
                            pagination={{
                              current: paginationMap[dept].current,
                              pageSize: paginationMap[dept].pageSize,
                              total: data.length,
                              showSizeChanger: true,
                              pageSizeOptions: ["10", "50", "100", "200"],
                              showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            }}
                          />
                        </div>
                      );
                    })
                )}
              </div>
            </div>
          </div>
        </div>

        {activeModal === "add" && (
          <EmployeeLeaveModelPopup
            leaveData={selectedLeave}
            isOpen={isModalOpen}
            onClose={handleModalClose}
            allLeaves={adminLeaves}
            remainingLeaves={9999}
            appliedByAdmin={true}
            employeeList={employeeList}
          />
        )}

        {activeModal === "edit" && (
          <AdminLeaveAddModelPopup
            leaveData={selectedLeave}
            isOpen={isModalOpen}
            onClose={handleModalClose}
          />
        )}

        <DeleteModal Name="Delete Leaves" />
      </div>
    </>
  );
};

export default AdminLeave;